<template>
  <div :class="{ 'animating': animating, 'aside-mobile-on': $store.state.mobileAsideOpen }" class="aside aside-light aside-hoverable" id="kt_aside">
    <div class="aside-logo flex-column-auto" id="kt_aside_logo">
      <router-link :to="{ name: 'home' }">
        <img alt="Logo" class="h-15px logo" src="../assets/logo.png" />
      </router-link>

      <div @click="toggle()" class="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
        id="kt_aside_toggle">
        <span class="svg-icon svg-icon-1">
          <i class="fad fa-chevron-double-right" v-if="isMinimized()"></i>
          <i class="fad fa-chevron-double-left" v-else></i>
        </span>
      </div>
    </div>
    <div class="aside-menu">
      <div class="hover-scroll-overlay-y my-5 my-lg-5" id="kt_aside_menu_wrapper">
        <div
          class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
          data-kt-menu="true" id="#kt_aside_menu">


          <template v-for="(menu , index) in store.state.mainStore.menus">
            <div :key="index" v-if="isMenuSelected(menu)">
              <div class="menu-item menu-title-gray-700" v-for="(sub , index) in menu.subMenus" :key="index">
                <template v-if="sub.title && isMenuAllowed(sub)" >
                  <div>
                    <div class="menu-content  pb-2">
                      <span class="menu-section text-muted text-uppercase fs-8 ls-1">{{ trans(sub.title) }}</span>
                    </div>
                  </div>
                </template>


                <template v-if="verifyMenuByPartner(store.state.settings, sub)">


                  <template v-if="sub.name">
                    <router-link :class="{ 'active': isActive(menu, sub) }" :to="{  name: sub.name, query: sub.params &&  sub.params.length > 0 && getParameters(sub.params) }" class="menu-link" v-if="isMenuAllowed(sub)">
                      <span class="menu-icon">
                        <span class="svg-icon svg-icon-2">
                          <i :class="sub.icon + ' '" v-if="sub.icon"></i>
                          <i class="fad fa-cogs" v-else></i>
                        </span>
                      </span>
                      <span class="menu-title d-flex justify-content-between align-items-center flex-grow-1">
                        <span>{{ sub.label ? trans(sub.label) : sub.name }}</span>
                        <span v-if="badgeFor(sub.name)"
                              class="badge badge-danger ms-2"
                              :title="'Escalades en attente : ' + badgeFor(sub.name)">
                          {{ badgeFor(sub.name) }}
                        </span>
                      </span>
                    </router-link>
                  </template>

                  <template v-else-if="sub.href">
                    <a :href="sub.href" target="_blank" :class="{ 'active': isActive(menu, sub) }" class="menu-link"
                      v-if="hasRole('ROLE_USER')">
                      <span class="menu-icon">
                        <span class="svg-icon svg-icon-2">
                          <i :class="sub.icon + ' '"></i>
                        </span>
                      </span>
                      <span class="menu-title">
                        {{ trans(sub.label) }}
                      </span>
                    </a>
                  </template>



                </template>





              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
    <div class="aside-footer flex-column-auto" id="kt_aside_footer"></div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { auth } from "@/services/Auth";
import ComparatorMenu from "@/layouts/Menus/ComparatorMenu.vue";
import menus from "@/router/Menu";
import { helper } from "@/services/Helper";
import store from "@/store";
import { navigationManager } from "@/services/NavigationManager";

@Component({
  computed: {
    store() {
      return store
    }
  },
  methods: {
    menus() {
      return store.state.mainStore.menus || menus
    }
  },
  components: { ComparatorMenu }
})
export default class LeftAside extends Vue {
  public route = 'dashboard';
  public selected = '';
  public minimized = 'on';
  public animating = false;

  // public isAdmin = true;

  isAdmin(): boolean {
    return auth.isAdmin();
  }

  /**
   * Compteur de badge pour un menu item. Aujourd'hui seul chat-escalations
   * affiche un badge : count des notifs type=ESCALATION encore dans le
   * dropdown (poussees par NotificationManager.handleEscalation). Les
   * badge se mettent donc a jour en temps reel quand une nouvelle escalade
   * arrive via FCM, et disparaissent quand l'admin les marque lues.
   */
  badgeFor(menuName: string): number {
    if (menuName !== 'chat-escalations') return 0
    const notifs = store.state.mainStore.notifications || []
    return notifs.filter((n: any) => n && n.type === 'ESCALATION').length
  }



  isMenuSelected(menu: any) {
    // Méthode 1 : Vérifier si la route actuelle est dans les sous-menus
    if (menu.subMenus && menu.subMenus.length > 0) {
      for (let sub of menu.subMenus) {
        // Vérification par nom de route (le plus fiable)
        if (sub.name === this.$route.name) {
          return true;
        }

        // Vérification par pathMatch si défini
        if (sub.pathMatch && this.$route.path.includes(sub.pathMatch)) {
          return true;
        }
      }
    }

    // Méthode 2 : Vérification par préfixe de path (comportement legacy)
    if (menu && menu.path) {
      const path = menu.path.replace(/^\/(.*)/, "$1");
      const currentPath = this.$route.path.replace(/^\/(.*)/, "$1")
      let root = path.split('/')[0]
      let currentRoot = currentPath.split('/')[0]
      return currentRoot === root
    }

    return false
  }
  isMenuAllowed(menu: any) {
    // console.log('check menu '+menu.name)
    return auth.checkRoleTabs(menu.roles)
  }
  toggle(): void {
    const state = document.body.getAttribute('data-kt-aside-minimize');
    if (state === 'on') {
      document.body.setAttribute('data-kt-aside-minimize', 'off');
    } else {
      this.animating = true;
      document.body.setAttribute('data-kt-aside-minimize', 'on');
      const t = setTimeout(() => {
        this.animating = false;
        clearTimeout(t);
      }, 500);
    }
    const newState = document.body.getAttribute('data-kt-aside-minimize');
    if (newState) {
      localStorage.setItem('navState', newState);
    }
    this.$forceUpdate();

  }

  isMinimized(): boolean {
    return this.minimized === 'on';
  }


  verifyMenuByPartner(settings: any, sub: any): boolean {
    if (!settings || settings === null) return true
    if (!settings.submenu || settings.submenu.length === 0) return true
    // Si la route est dans la whitelist → autorise
    if (settings.submenu.includes(sub.path)) return true
    // Si aucun sous-menu du meme parent n'est dans la whitelist → route hors scope, autorisee
    // (la restriction ne s'applique qu'aux menus que le gestionnaire a configures)
    const store = this.$store
    const parentMenu = store.state.mainStore.menus.find((m: any) =>
      m.subMenus && m.subMenus.some((s: any) => settings.submenu.includes(s.path))
      && m.subMenus.some((s: any) => s.path === sub.path)
    )
    if (!parentMenu) return true // Hors scope → autorise
    return false // Dans un menu restreint mais pas dans la whitelist → bloque
  }

  isActive(menu: any, sub: any): boolean {
    if (!helper.empty(sub.route)) {
      if (this.$route.name === sub.route.name) {
        return true
      }
      const menuRoute: any = this.$router.getRoutes().find((r: any) => {
        return r.name === sub.route.name
      })
      if (this.$route.fullPath?.startsWith(menuRoute.path)) {
        return true
      }
    }

    if (!helper.empty(sub.pathMatch)) {
      return this.$router.currentRoute.path.includes(sub.pathMatch)
    }

    return false
  }

  isOpen(name: string): boolean {
    return this.selected.trim().length > 0 && this.selected.includes(name);
  }


  isExactRoute(name: string): boolean {
    return name === this.route;
  }

  isRouted(array: Array<any>) {
    return array.includes(this.route)
  }

  select(name: string): void {
    if (this.selected && this.selected.includes(name)) {
      this.selected = '';
    } else {
      this.selected = name;
    }
  }

  pathIncludes(name: string) {
    return this.$router.currentRoute.path.includes(name)
  }


  getParameters(params: any) {


    let p: any = {}
    if (params) {
      params.forEach((param: any) => {
        if (param.label && param.value) {

          p[param.label] = param.value
        }
      })
    }
    return p
  }

  mounted(): void {


    if (this.$router.currentRoute.name) {
      this.route = this.$router.currentRoute.name;
      this.selected = this.$router.currentRoute.name;
    }
    // console.log(this.route)
    // console.log(this.$router.currentRoute.path)


    if (localStorage.getItem('navState')) {
      const navState = localStorage.getItem('navState');
      if (navState !== null) {
        this.minimized = navState;
        if (this.minimized === 'on') {
          document.body.setAttribute('data-kt-aside-minimize', 'on');
        } else {
          document.body.setAttribute('data-kt-aside-minimize', 'off');
        }
      }
    }

    // this.$store.getters.menus()
  }

  beforeDestroy() {

  }


}
</script>
<style scoped>
.open .menu-arrow {
  transform: rotateZ(90deg);
}

.open+.menu-sub {
  display: flex !important;
}

.router-link-exact-active {
  background: var(--bs-light-primary);
}

.router-link-exact-active .menu-title {
  color: var(--bs-primary) !important;
}
</style>
<style>
@media (max-width: 991.98px) {
  #kt_aside.aside-mobile-on {
    display: flex !important;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 280px;
    z-index: 1050;
    background: #fff;
    box-shadow: 5px 0 15px rgba(0,0,0,0.15);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  #kt_aside.aside-mobile-on .aside-logo {
    display: flex !important;
    padding: 15px 20px;
  }
  #kt_aside.aside-mobile-on .aside-toggle {
    display: none;
  }
  #kt_aside.aside-mobile-on .menu-link {
    min-height: 44px;
    font-size: 14px;
  }
  #kt_aside.aside-mobile-on .menu-title {
    color: #3f4254 !important;
  }
  #kt_aside.aside-mobile-on .menu-icon .svg-icon,
  #kt_aside.aside-mobile-on .menu-icon i {
    color: #7e8299;
  }
  #kt_aside.aside-mobile-on .router-link-exact-active .menu-title {
    color: var(--bs-primary) !important;
  }
  #kt_aside.aside-mobile-on .router-link-exact-active .menu-icon .svg-icon,
  #kt_aside.aside-mobile-on .router-link-exact-active .menu-icon i {
    color: var(--bs-primary);
  }
}
</style>
